<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="profile-falta-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span> 
                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="dataMin" class="form-label">Data Minima</label>
                                <input
                                    id="dataMin"
                                    v-model="dataMin"
                                    @keyup="apertouEnter"
                                    @blur="refreshTable"
                                    type="date"
                                    class="form-control form-control-solid"
                                />
                            </div>
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="dataMax" class="form-label">Data Maxima</label>
                                <input
                                    id="dataMax"
                                    v-model="dataMax"
                                    @keyup="apertouEnter"
                                    @blur="refreshTable"
                                    type="date"
                                    class="form-control form-control-solid"
                                />
                            </div>
                            <div class="col-12 col-md-6 col-lg-3" v-if="status">
                                <label for="statusFalta" class="form-label">Status</label>
                                <Multiselect
                                    id="statusFalta"
                                    v-model="status_id"
                                    :options="status_select"
                                    :searchable="true"
                                    @change="refreshTable"
                                />
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                            <th>Data</th>
                            <th>Disciplina</th>
                            <th>Aula</th>
                            <th>Motivo</th>
                            <th>Tipo Amparo</th>
                            <th>Status</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import FaltaService from "@/service/v10/sigap/FaltaService";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import Multiselect from "@vueform/multiselect";

    @Options({
        name: "FaltaIndex",
        components: { CardRh, KDataTable, Multiselect },
    })
    export default class FaltaIndex extends Vue {
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public status_id: any = null;
        public matriculaId: any = null;
        public status: any = null;
        public dataMin = '';
        public dataMax = '';

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }
 

        get status_select() {
            if (this.status) {
                return this.status.map((item) => {
                    return { value: item.id, label: item.nome };
                });
            }
            return [];
        }

        public getStatus() {
            this.processando = true;
            this.service.getStatus()
                .then(response => {
                    this.status = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new FaltaService();
            this.getStatus();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        DataMin: this.dataMin,
                        DataMax: this.dataMax,
                        status: this.status_id,
                        matriculaId: this.matriculaId,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: 'data', name: 'data' },
                { data: 'disciplina', name: 'disciplina' },
                { data: 'aula', name: 'aula', class: 'desktop' },
                { data: 'faltaMotivo', name: 'faltaMotivo', class: 'desktop' },
                { data: 'faltaTipo', name: 'faltaTipo', class: 'desktop' },
                { data: 'status', name: 'status', searchable: false, class: 'text-center desktop' },
            ];

            this.config.columnDefs = [
                {
                    targets: 0,
                    render: (row, type, val) => {
                        return SiteUtils.formatData(val.aula.data);
                    }
                },
                {
                    targets: 1,
                    render: (row) => {
                        return row != null ? row.descricao : '';
                    }
                },
                {
                    targets: 2,
                    render: (row) => {
                        return row != null ? row.numero : '';
                    }
                },
                {
                    targets: 3,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 4,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 5,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
            ];
        }
    }
</script>

<style scoped>
    .profile-falta-page {
        display: grid;
        gap: 24px;
    }

    .filter-panel,
    .table-panel {
        border: 1px solid #e5edf6;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
        padding: 15px;
    }

    .filter-panel {
        position: relative;
        padding-top: 24px;
    }

    .panel-border-label {
        position: absolute;
        top: -9px;
        left: 18px;
        padding: 0 10px;
        background: #ffffff;
        color: #102542;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1.4;
    }

    .table-panel {
        padding: 2px 10px !important;
    }

    .panel-heading {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 10px;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e9eef5;
    }

    .panel-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .btn-sm {
        margin-left: 10px;
    }

    .panel-actions .btn-sm {
        margin-left: 0;
    }

    @media screen and (max-width: 991px) {
        .filter-panel,
        .table-panel {
            padding: 18px;
            border-radius: 18px;
        }

        .filter-panel {
            padding-top: 26px;
        }

        .panel-heading {
            flex-direction: column;
            align-items: stretch;
        }
    }
</style>
